// extracted by mini-css-extract-plugin
module.exports = {"link":"index-link-1lu9o","opacity":"index-opacity-3iJ9l","brightness":"index-brightness-2cOjK","underline":"index-underline-3e1Lb"};